import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'
import { toast } from '../base/components/toast/toastConfig'
import lang from '@/lang'
import { isUndefined, omitBy } from 'lodash'

const EmailService = {
  fetchEmailAccounts(accountType, setAccountList) {
    return request(`${settingsConfig.emailAccountsList}?accountType=${accountType}`, { auth: true, isConcurrent: true })
      .then(({ body: { data: accountList } }) => {
        setAccountList && setAccountList(accountList)
        return accountList
      }).then(accountList => {
        const noDefault = !(accountList.some((account) => account.isDefault))
        if (noDefault && accountList[0]?.id) {
          return request(`${settingsConfig.setAccountAsDefault}/${accountList[0].id}`, { auth: true, method: 'PUT', isConcurrent: true })
        }
        return accountList
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  },
  fetchEmailAccount(emailAccountId, setAccount) {
    return request(`${settingsConfig.getEmailAccountSettings}/${emailAccountId}`, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        setAccount && setAccount(data)
        return data
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  },
  fetchEmailServiceStatus(setEmailServiceStatus) {
    return request(settingsConfig.getEmailServiceSetup, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        setEmailServiceStatus(data)
        return data
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  },
  sendEmailServiceStatus({ useOwnEmailServer, useSyncEmailAccounts }, onSuccess) {
    return request(`${settingsConfig.emailServiceSetup}`,
      { auth: true, method: 'PUT', data: omitBy({ useOwnEmailServer, useSyncEmailAccounts }, isUndefined) },
    )
      .then(() => {
        toast.showToast({ message: lang.changeSuccess })
        onSuccess && onSuccess()
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  },
  fetchEmailSingature(setEmailSignature) {
    return request(settingsConfig.getEmailSignature, { auth: true, isConcurrent: true })
      .then(({ body: { data: signatureData } }) => {
        const { emailSign } = signatureData
        setEmailSignature && setEmailSignature(emailSign)
        return emailSign
      })
      .catch(() => toast.showToast({ message: lang.defaultErrorMessage, type: 'error' }))
  },
  saveEmailSignature(signature, { silent = false } = {}) {
    return request(settingsConfig.setEmailSignature, {
      method: 'PUT',
      auth: true,
      data: {
        emailSign: signature,
      },
    }).then(() => {
      if (!silent) {
        toast.showToast({ message: lang.accountSignatureSuccessMessage })
      }
    })
      .catch(() => toast.showToast({ type: 'error', message: lang.accountSignatureErrorMessage }))
  },
  setEmailAccountAsDefault(id) {
    return request(`${settingsConfig.setAccountAsDefault}/${id}`, { auth: true, method: 'PUT', isConcurrent: true })
      .then(() => {
        toast.showToast({ message: lang.changeSuccess })
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
  },
  createEmailAccount(data) {
    return request(settingsConfig.createEmailAccount, {
      auth: true,
      method: 'POST',
      data,
      isConcurrent: true,
      timeout: 2e5,
    })
  },
  updateEmailAccount(data) {
    return request(settingsConfig.updateEmailAccount + `/${data.id}`, {
      auth: true,
      method: 'PUT',
      data,
      isConcurrent: true,
    })
  },
  deleteEmailAccount(id, deleteEmails = false) {
    return request(settingsConfig.deleteEmailAccount + `/${id}`, {
      auth: true,
      method: 'DELETE',
      isConcurrent: true,
      data: { deleteEmails },
    })
  },
  async getEmailOAuthConfig(provider) {
    const response = await request(settingsConfig.getEmailOAuthConfig + `/${provider}`, {
      auth: true,
    })
    return response?.response?.data?.data
  },
}

export default EmailService
